'use client'
import { createRef, forwardRef, InputHTMLAttributes } from 'react'
import cn from 'classnames'
import { IMaskInput } from 'react-imask'

import styles from './FormInput.module.scss'

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  error?: string
  mask?: any
}
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ className, error, mask, ...props }, ref) => {
    const localRef = createRef()
    return (
      <div
        className={cn(styles.container, className, {
          [styles.isError]: error != null && error.length !== 0,
        })}
      >
        {/* @ts-ignore */}
        <IMaskInput
          className={styles.input}
          type="text"
          mask={mask}
          inputRef={ref}
          ref={localRef}
          {...props}
        />
        {error != null && error.length !== 0 ? (
          <span className={styles.error}>{error}</span>
        ) : null}
      </div>
    )
  }
)
FormInput.displayName = 'FormInput'
